import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.column.key === 'index')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createTextVNode(_toDisplayString(_ctx.index + 1), 1)
      ], 64))
    : (_ctx.column.key === 'company' && _ctx.row.company)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(_toDisplayString(_ctx.row.company.shortName), 1)
        ], 64))
      : (_ctx.column.key === 'invoiceNumber')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            class: "TripsLink",
            to: `/invoice/${_ctx.row.invoiceId}`,
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.row.invoiceNumber), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key] || '-'), 1)
          ], 64))
}